// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1wmoV","title":"Info_title__1KUCP","selects":"Info_selects__2kY3i","requiredAsterisk":"Info_requiredAsterisk__1Yz4I"};